import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  get navigationErrors$(): Observable<NavigationError> {
    return this._router.events.pipe(
      filter((e) => e instanceof NavigationError),
      map((e) => e as NavigationError),
    );
  }
  get navigationEnd$(): Observable<NavigationEnd> {
    return this._router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map((e) => e as NavigationEnd),
    );
  }

  get navigationStart$(): Observable<NavigationStart> {
    return this._router.events.pipe(
      filter((e) => e instanceof NavigationStart),
      map((e) => e as NavigationStart),
    );
  }

  constructor(private _router: Router, private _activatedRoute: ActivatedRoute) {}
}
